export type RawLimit = {
  readonly value: number;
  readonly currency: string;
};

export const iniRawLimit: RawLimit = {
  value: 1,
  currency: "",
};
